import { Fragment } from "react";
import { FormattedMessage as FM } from "react-intl";
import { Menu, Transition } from "@headlessui/react";

import { ChevronDownIcon } from "components/Icons";

import { useNavigate, Link } from "react-router";
import { clearStorage } from "store/local";
import { classNames } from "tools/ui";
import proxy from "api/proxy";

export default function DropUser({ session }) {
  const navigate = useNavigate();

  async function handleSignOut() {
    await proxy.logout();
    clearStorage();
    if (session.web_user) {
      navigate("/loginCustomer");
    } else {
      navigate("/login");
    }
    window.location.reload();
  }

  return (
    <Menu as="div" className="relative inline-block text-left rounded-md">
      <div>
        <Menu.Button className="inline-flex w-full justify-center px-4 truncate text-sm font-medium text-white shadow-sm outline-none my-auto">
          {session?.user_name}
          <ChevronDownIcon
            className="-mr-1 ml-2 h-5 w-5 fill-current"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="!z-auto absolute right-0 mt-2 w-56 origin-top-right divide-y divide-neutral-100 rounded-md bg-white shadow-lg ring-1 ring-neutral-200 ring-opacity-5 focus:outline-none">
          <div className="px-4 py-3">
            <p className="text-sm text-neutral-500">
              <FM id="navbar.signed_as" key="signed_as" />
            </p>
            <p className="truncate text-sm font-medium text-neutral-900">
              {session?.login}
            </p>
          </div>
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="/dash/profile"
                  className={classNames(
                    active
                      ? "bg-neutral-100 text-neutral-900"
                      : "text-neutral-700",
                    "block px-4 py-2 text-sm",
                  )}
                >
                  <FM id="navbar.profile" key="profile" />
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <a
                  href="https://www.presik.com/help/support"
                  className={classNames(
                    active
                      ? "bg-neutral-100 text-neutral-900"
                      : "text-neutral-700",
                    "block px-4 py-2 text-sm",
                  )}
                >
                  <FM id="navbar.support" key="support" />
                </a>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <a
                  href="https://www.presik.com/help/resources"
                  className={classNames(
                    active
                      ? "bg-neutral-100 text-neutral-900"
                      : "text-neutral-700",
                    "block px-4 py-2 text-sm",
                  )}
                >
                  <FM id="navbar.license" key="license" />
                </a>
              )}
            </Menu.Item>
          </div>
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                onClick={handleSignOut}
                className={classNames(
                  active
                    ? "bg-neutral-100 text-neutral-900"
                    : "text-neutral-700",
                  "block w-full px-4 py-2 text-left text-sm",
                )}
              >
                <FM id="navbar.signout" key="signout" />
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
